// styling
import styles from './style.module.scss';
// components
import { faRightLong } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// assets
import classNames from 'classnames';

const Investing = () => {

    const paragraphs = [
        { p: 'While materializing an idea into a visual format is already challenging, being an independent creator is also a costly and risky endeavor. Our platform aims to reduce barriers associated with creating visual content and provide an opportunity for anyone who desires to create sequential art to create like a studio without the financial expense and risks of intellectual property and creative control.', },
        { p: 'The cost per page is set at $50 to reflect the current industry minimum. Generally, to produce a sequential artwork, the average cost is much higher*.', },
    ];

    return (
        <section className={styles.section}>
            {/* <img className={styles.shape} src={shape} alt="media" /> */}
            <div className={`${styles.container} container`}>
                <div className="d-flex flex-column g-10">
                    <p className={styles.pPlat}>INVEST</p>
                    <p className={styles.pPlatText}>
                        By <span className={styles.pPlatTextSpan}>Investing</span> With Us, You Can Help Turn <span className={styles.pPlatTextSpan}>Dreams Into A Reality!</span>
                    </p>
                </div>
                <div className={classNames(styles.main, styles.pInvesting)}>
                    {paragraphs.map((para, index) => (
                        <p key={index}><FontAwesomeIcon
                            icon={faRightLong}
                            size="sm"
                        /> {para.p}</p>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Investing